import React, { useState, useRef, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl, useIntl } from 'react-intl'
import WidgetsModel from './WidgetsModel'
import zonePanelsConfig, { SignageZonePanel, AddSignageButton } from './zonePanelsConfig'
import FooterActions from '../../../components/SignagePlus/FooterActions'
import stepCurrent from '../../../assets/icons/signage-plus/step-current.svg'
import stepFinish from '../../../assets/icons/signage-plus/step-finish.svg'
import SelectDestination from './SelectDestination'
import './CreateSignage.css'
import SignageMainConfigPanel from './SignageMainConfigPanel'
import ScheduleDateTimePanel from './ScheduleDateTimePanel'
import OverviewPanel from './OverviewPanel'
import xCircleFill from '../../../assets/icons/signage-plus/x-circle-fill.svg'
import successful from '../../../assets/icons/common/successful.svg';
import NotificationModal from '../../../components/MessageManager/NotificationModal';
import AddPlaylist from './AddPlaylist';
import TickerMessage from './TickerMessage';
import constants from '../../../utils/constants';
import { signageDelete, setUnsavedChanges } from '../../../store/signage';
import { SIGNAGE_MEDIA } from '../../../utils/constants';
import API from '../../../utils/API';
import Toast from '../../../components/Toast/Toast';
import Clock from '../../../components/SignagePlus/Clock'
import Weather from '../../../components/SignagePlus/Weather'
import Calendar from '../../../components/SignagePlus/Calendar'
import SignageModal from './SignageModal';

function CreateSignage(props) {
  const navigate = useNavigate();
  const { user, signage } = props;
  const permissionIds = user.permissions.map(permission => permission.id);

  if (!(permissionIds.includes(constants.permissionIds.signagePlusOwner) || permissionIds.includes(constants.permissionIds.signagePlusTeacher))) {
    navigate('/forbidden');
  }
  const [isPreNormal, setIsPreNormal] = useState(false);
  const [signageName, setSignageName] = useState('');
  const [zoneType, setZoneType] = useState('10');
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [leftLabel, setLeftLabel] = useState("CANCEL");
  const [middleLabel, setMiddleLabel] = useState("");
  const [saveLabel, setSaveLabel] = useState("SCHEDULE_SIGNAGE");
  const modalRef = useRef(null);
  const [nodes, setNodes] = useState([]);
  const [zone, setZone] = useState('');

  const [scheduler, setScheduler] = useState({
    startingDate: null,
    endingDate: null,
    startingTime: null,
    endingTime: null,
    repeat: SIGNAGE_MEDIA.CREATE_SIGNAGE.DAILY,
    recurringDays: [false, false, false, false, false, false, false],
  });
  const [receivers, setReceivers] = useState([]);
  const [zoneData, setZoneData] = useState({});
  const [signageNameValid, setSignageNameValid] = useState("");
  const [signageNameToastValid, setSignageNameToastValid] = useState("");
  const [startingDateValid, setStartingDateValid] = useState("");
  const [startingTimeValid, setStartingTimeValid] = useState("");
  const [endingDateValid, setEndingDateValid] = useState("");
  const [endingTimeValid, setEndingTimeValid] = useState("");
  const [recurringValid, setRecurringValid] = useState("");
  const [validated, setValidated] = useState("");
  const [receiversValid, setReceiversValid] = useState("");
  const [zoneListValid, setZoneListValid] = useState("");
  const [playListLengthValid, setPlayListLengthValid] = useState(0);
  const [conflictSignage, setConflictSignage] = useState([]);
  const [disableSave, setDisableSave] = useState(false);
  const [disableDrafts, setDisableDrafts] = useState(false);

  const [currentPage, setCurrentPage] = useState(signage?.current ?? 0);
  const signageRef = useRef(signage);

  const [notificationProps, setNotificationProps] = useState({
    icon: successful,
    message: 'SIGNAGE_SCHEDULED',
    description: 'SIGNAGE_SCHEDULED_DESCRIPTION',
    primaryButtonText: 'CONTINUE',
    className: 'green',
    onSubmit: () => {
      setSuccess("");
      setError("");
      modalRef.current.hide();
      if ((permissionIds.includes(constants.permissionIds.signagePlusOwner))) {
        document.getElementById('signagePlusDashboardTab').click();
      } else if ((permissionIds.includes(constants.permissionIds.signagePlusTeacher))) {
        document.getElementById('signagePlusTeacherDashboardTab').click();
      }
      else {
        window.location.reload();
      }
    }
  });

  const zoneOptions = {
    10: "ZONE_1_SIGNAGE",
    20: "ZONE_2_SIGNAGE_WIDGET",
    31: "ZONE_3A_SIGNAGE_2WIDGET",
    32: "ZONE_3B_SIGNAGE_WIDGET_TICKER",
    40: "ZONE_4_SIGNAGE_2WIDGET_TICKER"
  };

  useEffect(() => {
    if (signageRef.current.id) {
      const fetchSignageData = async () => {
        try {
          const res = await API.getSignageById(signageRef.current.id);
          const data = res.data;
          if (data) {
            setIsPreNormal(data.status === 'normal');
            setPlayListLengthValid(data.content.filter(item => item.zone === SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST)[0]?.content.length || 0);
            setSignageName(data.title);
            setZoneType(data.zoneType.toString());
            if (signageRef.current.menuid != "signagePlusDraftsTab") {
              setScheduler((prev) => ({
                ...prev,
                id: data.scheduler.id,
                startingDate: new Date(new Date(data.scheduler.timeStart).toLocaleDateString()),
                endingDate: new Date(new Date(data.scheduler.timeEnd).toLocaleDateString()),
                startingTime: new Date('1970-01-01T' + timeToHHMMSS(data.scheduler.timeStart)),
                endingTime: new Date('1970-01-01T' + timeToHHMMSS(data.scheduler.timeEnd)),
                repeat: data.scheduler.type,
                recurringDays: data.scheduler.recurrenceDays
              }));
              setReceivers(data.receivers ? data.receivers.map(receiver => `${receiver.groupId}+${receiver.mac}`) : []);
            }
            const transformedZoneData = data.content.reduce((acc, item) => {
              acc[item.zone] = item;
              return acc;
            }, {});
            setZoneData(transformedZoneData);
          }

        } catch (error) {
          setError(<FormattedMessage id={error?.response?.data?.message || ''} defaultMessage={error.message} />);
        }
      }
      fetchSignageData();
    }
    modalRef.current = new window.bootstrap.Modal(document.getElementById('notificationModal'));
    return () => {
      if (signageRef.current.id) {
        props.dispatch(signageDelete());
      }
    }
  }, []);

  const closeModal = (modalId) => {
    const modal = document.getElementById(modalId);
    if (modal) {
      const closeButton = modal.querySelector(
        '.btn-close, [data-bs-dismiss="modal"]'
      );
      if (closeButton) {
        closeButton.click();
      }
    }
  };

  const markUnsavedChanges = () => {
    props.dispatch(setUnsavedChanges(true));
  }

  const fetchReceivers = async () => {
    try {
      const res = await API.getGroupReceiverByUser();
      const tree = [];
      const processGroupItem = (item) => {
        const model = { label: item.name, value: item.id };
        if (item.receivers) {
          model.children = item.receivers.map((receiver) => {
            return { label: receiver.name, value: item.id + '+' + receiver.mac, key: item.id + '+' + receiver.mac };
          });
        }
        return model;
      };

      res.data.forEach((item) => {
        tree.push(processGroupItem(item));
      });
      setNodes([{
        value: '-1',
        label: 'Select All Departments',
        type: '',
        children: tree
      }]);
    } catch (error) {
      console.log(error);
      setError(<FormattedMessage id={error?.response?.data?.message || ''} defaultMessage={error.message} />);
    }
  };
  useEffect(() => {
    if (currentPage === 0) {
      setLeftLabel("CANCEL");
      setMiddleLabel("SAVE_TO_DRAFTS");
      setSaveLabel("SCHEDULE_SIGNAGE");
    } else {
      setLeftLabel("PREVIOUS");
      setMiddleLabel("CANCEL");
      setSaveLabel("NEXT");
    }
    if (currentPage === 2) {
      setConflictSignage([]);
      fetchReceivers();
    }
  }, [currentPage]);

  useEffect(() => {
    if (scheduler.startingDate) {
      setStartingDateValid("");
    } else {
      setStartingDateValid("EMPTY_FIELD_ERROR");
    }
  }, [scheduler.startingDate]);

  useEffect(() => {
    if (scheduler.endingDate) {
      setEndingDateValid("");
    } else {
      setEndingDateValid("EMPTY_FIELD_ERROR");
    }
  }, [scheduler.endingDate]);

  useEffect(() => {
    if (scheduler.startingTime) {
      setStartingTimeValid("");
    } else {
      setStartingTimeValid("EMPTY_FIELD_ERROR");
    }
  }, [scheduler.startingTime]);

  useEffect(() => {
    if (scheduler.endingTime) {
      setEndingTimeValid("");
    } else {
      setEndingTimeValid("EMPTY_FIELD_ERROR");
    }
  }, [scheduler.endingTime]);
  useEffect(() => {
    if (scheduler.repeat === SIGNAGE_MEDIA.CREATE_SIGNAGE.RECURRING) {
      setRecurringValid(scheduler.recurringDays.some(day => day) ? '' : 'RECURRING_TIME_ERROR');
    } else {
      setRecurringValid('');
    }
  }, [scheduler.recurringDays, scheduler.repeat]);

  useEffect(() => {
    if (receivers.length > 0) {
      setReceiversValid("");
    } else {
      setReceiversValid("SELECT_RECEIVER_WARNING");
    }
  }, [receivers]);

  useEffect(() => {
    if (signageName.trim().length === 0) {
      setSignageNameValid("EMPTY_FIELD_ERROR");
      setSignageNameToastValid("SIGNAGE_NAME_REQUIRED");
    } else if (signageName.trim().length < 2 || signageName.trim().length > 36) {
      setSignageNameValid("SIGNAGE_NAME_LENGTH_ERROR");
      setSignageNameToastValid("SIGNAGE_NAME_REQUIRED");
    } else {
      setSignageNameValid("");
      setSignageNameToastValid("");
    }
  }, [signageName]);

  const tabs = [
    { label: 'DATE&TIME', id: 1 },
    { label: 'DESTINATION', id: 2 },
    { label: 'OVERVIEW', id: 3 }
  ];
  const handleReceiversChange = (checked) => {
    setReceivers(checked);
  }
  // TabsPanel component
  const TabsPanel = () => {
    return (
      <>
        <div className="d-flex mt-3" style={{ height: 91, gap: 5 }}>
          {tabs.map((tab, idx) => {
            let iconNode = null;
            if (currentPage === idx + 1) {
              iconNode = (
                <img className='icon-44'
                  src={stepCurrent}
                  alt="current"
                />
              );
            } else if (currentPage > idx + 1) {
              iconNode = (
                <img className='icon-44'
                  src={stepFinish}
                  alt="finish"
                />
              );
            } else {
              iconNode = (
                <div
                  className="rounded-circle icon-44 d-flex"
                  style={{
                    border: '1px solid rgba(0, 0, 0, 1)',
                    background: 'none'
                  }}
                />
              );
            }
            return (
              <div
                key={tab.id}
                className="d-flex flex-column align-items-center"
                style={{
                  flex: 1,
                  borderBottom: currentPage === idx + 1
                    ? '3px solid rgba(0, 80, 131, 1)'
                    : '1px solid rgba(204, 203, 204, 1)',
                  color: currentPage === idx + 1 ? '#005083' : '#222',
                }}
              >
                {iconNode}
                <span
                  className="w-100 text-center fw-semibold text-capitalize mt-2 line-height-24">
                  <FormattedMessage id={tab.label} />
                </span>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  const combineDateTime = (date, time) => {
    const dateTemp = new Date(date);
    const timeTemp = new Date(time);
    return new Date(
      dateTemp.getFullYear(),
      dateTemp.getMonth(),
      dateTemp.getDate(),
      timeTemp.getHours(),
      timeTemp.getMinutes(),
      timeTemp.getSeconds()
    );
  }
  const checkIsInstant = () => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const combinedStartingTime = combineDateTime(scheduler.startingDate < today ? now: scheduler.startingDate, scheduler.startingTime);
    const combinedEndingTime = combineDateTime(scheduler.startingDate < today ? now: scheduler.startingDate, scheduler.endingTime);

    let isInstant = false;
    if (now > combinedStartingTime && now < combinedEndingTime) {
      if (scheduler.repeat === SIGNAGE_MEDIA.CREATE_SIGNAGE.DAILY) {
        isInstant = true;
      } else {
        let currentDay = now.getDay();
        currentDay = currentDay === 0 ? 7 : currentDay;
        isInstant = scheduler.recurringDays[currentDay - 1];
      }
    }
    return {
      isInstant,
      instantStartingTime: isInstant ? toIsoStringWithOffset(combinedStartingTime) : null
    };
  };

  const timeNextRun = () => {
    let combinedStartingTime = combineDateTime(scheduler.startingDate, scheduler.startingTime);
    const now = new Date();

    if (combinedStartingTime < now) {
      combinedStartingTime = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        combinedStartingTime.getHours(),
        combinedStartingTime.getMinutes(),
        combinedStartingTime.getSeconds()
      );

      if (combinedStartingTime < now) {
        combinedStartingTime.setDate(combinedStartingTime.getDate() + 1);
      }
    }

    if (scheduler.repeat === SIGNAGE_MEDIA.CREATE_SIGNAGE.DAILY) {
      return combinedStartingTime;
    }

    let currentDay = combinedStartingTime.getDay() === 0 ? 7 : combinedStartingTime.getDay();
    while (combinedStartingTime <= now || !scheduler.recurringDays[currentDay - 1]) {
      combinedStartingTime.setDate(combinedStartingTime.getDate() + 1);
      currentDay = combinedStartingTime.getDay() === 0 ? 7 : combinedStartingTime.getDay();
    }

    return combinedStartingTime;
  };

  const dateToYYYYMMDD = (date) => {
    const dateTemp = new Date(date);
    const year = dateTemp.getFullYear();
    const month = (dateTemp.getMonth() + 1).toString().padStart(2, "0");
    const day = dateTemp.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const timeToHHMMSS = (date) => {
    const dateTemp = new Date(date);
    const hour = dateTemp.getHours().toString().padStart(2, "0");
    const minute = dateTemp.getMinutes().toString().padStart(2, "0");
    const second = dateTemp.getSeconds().toString().padStart(2, "0");
    return `${hour}:${minute}:${second}`;
  }

  useEffect(() => {
    const zoneTypeConditions = {
      '10': !zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST],
      '20': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1]),
      '31': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2]),
      '32': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]),
      '40': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]),
    };
    const zoneListStatus = zoneTypeConditions[zoneType]
      ? "SELECT_ZONE"
      : playListLengthValid === 0
        ? "SELECTED_PLAYLIST_NULL"
        : "";

    setZoneListValid(zoneListStatus);
  }, [zoneType, zoneData, playListLengthValid]);

  function toIsoStringWithOffset(date) {
    var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function (num) {
        return (num < 10 ? '0' : '') + num;
      };

    return date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds()) +
      dif + pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' + pad(Math.abs(tzo) % 60);
  }

  const formatDateTimeToISOString = (date, time) => {
    return new Date(`${dateToYYYYMMDD(date)}T${timeToHHMMSS(time)}`).toISOString();
  };

  const checkSignageConflict = async () => {
    const res = await API.checkSignageConflict(signageRef.current.id || "", {
      scheduler: {
        type: scheduler.repeat,
        //dateStart: dateToYYYYMMDD(scheduler.startingDate),
        //dateEnd: dateToYYYYMMDD(scheduler.endingDate),
        timeStart: formatDateTimeToISOString(scheduler.startingDate, scheduler.startingTime),
        timeEnd: formatDateTimeToISOString(scheduler.endingDate, scheduler.endingTime),
        timeNextRun: toIsoStringWithOffset(timeNextRun()),//timeNextRun().toISOString(),
        endDateTime: toIsoStringWithOffset(combineDateTime(scheduler.endingDate, scheduler.endingTime)),//combineDateTime(scheduler.endingDate, scheduler.endingTime).toISOString(),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        recurrenceDays: scheduler.recurringDays,
        ...checkIsInstant(),
      },
      receivers: receivers.map((item) => {
        const [groupId, mac] = item.split('+');
        return { groupId, mac };
      })
    })
    setConflictSignage(res.data.length > 0 ? res.data : []);
    return res.data.length > 0;
  }

  const validateTimeRange = () => {
    const startingDate = new Date(scheduler.startingDate);
    const endingDate = new Date(scheduler.endingDate);
    const startingTime = new Date('1970-01-01T' + timeToHHMMSS(scheduler.startingTime));
    const endingTime = new Date('1970-01-01T' + timeToHHMMSS(scheduler.endingTime));

    if (startingDate > endingDate || startingTime >= endingTime) {
      setError(<FormattedMessage id="STARTING_TIME_ERROR" />);
      return false;
    }

    const {isInstant, instantStartingTime} = checkIsInstant();
    const nextRun = new Date(timeNextRun().toISOString());
    const endDateTime = new Date(formatDateTimeToISOString(scheduler.endingDate, scheduler.endingTime));

    if ((isInstant && new Date(instantStartingTime) > endDateTime) || (!isInstant && nextRun > endDateTime)) {
      setError(<FormattedMessage id="NEXT_RUN_EXCEED_ENDING_TIME" />);
      return false;
    }

    return true;
  };

  const handleNext = async () => {
    setDisableSave(false);
    try {
      if (currentPage === 0) {
        const zoneTypeConditions = {
          '10': !zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST],
          '20': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1]),
          '31': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2]),
          '32': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]),
          '40': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]),
        };

        if (zoneTypeConditions[zoneType]) {
          setValidated(true);
          setZoneListValid("SELECT_ZONE");
          return;
        } else if (playListLengthValid === 0) {
          setValidated(true);
          setZoneListValid("SELECTED_PLAYLIST_NULL");
          return;
        } else {
          setZoneListValid("");
        }

        if (signageNameValid) {
          setValidated(true);
          setSignageNameToastValid("SIGNAGE_NAME_REQUIRED");
          return;
        }
        else {
          setSignageNameToastValid("");
        }
        if (zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST].length === 0) {
          setError(<FormattedMessage id="" />);
          return;
        }
      }
      if (currentPage === 1) {
        if (startingDateValid || endingDateValid || startingTimeValid || endingTimeValid || recurringValid) {
          setValidated(true);
          return;
        }
        if (scheduler.startingDate && scheduler.endingDate && scheduler.startingTime && scheduler.endingTime) {
          if (!validateTimeRange()) {
            return;
          }
        }
      }
      if (currentPage === 2) {
        if (receivers.length === 0) {
          setReceiversValid("SELECT_RECEIVER_WARNING");
        }

        if (receiversValid) {
          setError(<FormattedMessage id={receiversValid} />);
          setValidated(true);
          return;
        }
        await checkSignageConflict();
      }
      if (currentPage === 3) {
        setDisableSave(true);
        let hasConflict = await checkSignageConflict();
        if (hasConflict) {
          setDisableSave(false);
          return;
        };
        if (scheduler.startingDate && scheduler.endingDate && scheduler.startingTime && scheduler.endingTime) {
          if (!validateTimeRange()) {
            return;
          }
        }
        const signageData = {
          title: signageName.trim(),
          zoneType: zoneType,
          status: SIGNAGE_MEDIA.CREATE_SIGNAGE.NORMAL,
          content: [],
          scheduler: {
            type: scheduler.repeat,
            // dateStart: dateToYYYYMMDD(scheduler.startingDate),
            // dateEnd: dateToYYYYMMDD(scheduler.endingDate),
            timeStart: formatDateTimeToISOString(scheduler.startingDate, scheduler.startingTime),
            timeEnd: formatDateTimeToISOString(scheduler.endingDate, scheduler.endingTime),
            timeNextRun: toIsoStringWithOffset(timeNextRun()),//timeNextRun().toISOString(),
            endDateTime: toIsoStringWithOffset(combineDateTime(scheduler.endingDate, scheduler.endingTime)),//combineDateTime(scheduler.endingDate, scheduler.endingTime).toISOString(),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            recurrenceDays: scheduler.recurringDays,
            ...checkIsInstant(),
          },
          receivers: receivers.map((item) => {
            const [groupId, mac] = item.split('+');
            return { groupId, mac };
          }),
        };

        switch (zoneType) {
          case '10':
            signageData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST]];
            break;
          case '20':
            signageData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1]];
            break;
          case '31':
            signageData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2]];
            break;
          case '32':
            signageData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]];
            break;
          case '40':
            signageData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]];
            break;
          default:
            break;
        }
        console.log(signageData);
        const isUpdate = signageRef.current.id && signageRef.current.menuid !== 'signagePlusDraftsTab';
        if (isUpdate) {
          signageData.id = signageRef.current.id;
          await API.updateSignage(signageRef.current.id, signageData);
        } else {
          await API.addSignage(signageData);
        }

        setNotificationProps({
          icon: successful,
          message: 'SIGNAGE_SCHEDULED',
          description: 'SIGNAGE_SCHEDULED_DESCRIPTION',
          primaryButtonText: 'CONTINUE',
          className: 'green',
          onSubmit: () => {
            setSuccess("");
            setError("");
            setDisableSave(false);
            modalRef.current.hide();
            if ((permissionIds.includes(constants.permissionIds.signagePlusOwner))) {
              document.getElementById('signagePlusDashboardTab').click();
            } else if ((permissionIds.includes(constants.permissionIds.signagePlusTeacher))) {
              document.getElementById('signagePlusTeacherDashboardTab').click();
            }
            else {
              window.location.reload();
            }
          }
        });
        modalRef.current.show();
        props.dispatch(setUnsavedChanges(false));
      }
    } catch (error) {
      setDisableSave(false);
      console.error(error);
      setError(<FormattedMessage id="SIGNAGE_SCHEDULED_FAILED" values={{ errorMsg: <b>{error.message}</b> }} />);
      return;
    }
    setValidated(false);
    setCurrentPage(prev => (prev < 3 ? prev + 1 : prev));
  };

  const saveDrafts = async () => {
    setDisableDrafts(true);
    try {
      const zoneTypeConditions = {
        '10': !zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST],
        '20': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1]),
        '31': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2]),
        '32': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]),
        '40': !(zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2] && zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]),
      };

      if (zoneTypeConditions[zoneType]) {
        setValidated(true);
        setZoneListValid("SELECT_ZONE");
        setDisableDrafts(false);
        return;
      } else if (playListLengthValid === 0) {
        setValidated(true);
        setZoneListValid("SELECTED_PLAYLIST_NULL");
        setDisableDrafts(false);
        return;
      } else {
        setZoneListValid("");
      }

    if (signageNameValid) {
      setValidated(true);
      setSignageNameToastValid("SIGNAGE_NAME_REQUIRED");
      setDisableDrafts(false);
      return;
    } else {
      setSignageNameToastValid("");
    }
    const draftsData = {
      title: signageName.trim(),
      zoneType: zoneType,
      status: SIGNAGE_MEDIA.CREATE_SIGNAGE.DRAFT,
      content: [],
    };
    switch (zoneType) {
      case '10':
        draftsData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST]];
        break;
      case '20':
        draftsData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1]];
        break;
      case '31':
        draftsData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2]];
        break;
      case '32':
        draftsData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]];
        break;
      case '40':
        draftsData.content = [zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET1], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.WIDGET2], zoneData[SIGNAGE_MEDIA.CREATE_SIGNAGE.TICKER]];
        break;
      default:
        break;
    }

      const isUpdate = !isPreNormal && signageRef.current.id;
      if (isUpdate) {
        draftsData.id = signageRef.current.id;
        await API.updateDrafts(signageRef.current.id, draftsData);
      } else {
        await API.addDrafts(draftsData);
      }

      props.dispatch(setUnsavedChanges(false));
      setNotificationProps({
        icon: successful,
        message: 'SIGNAGE_DRAFT_SAVED',
        primaryButtonText: 'CONTINUE',
        className: 'green',
        onSubmit: () => {
          setSuccess("");
          setError("");
          modalRef.current.hide();
          document.getElementById('signagePlusDraftsTab').click();
        }
      })
      modalRef.current.show();
      setDisableDrafts(false);
    } catch (error) {
      setDisableDrafts(false);
      console.error(error);
      if (error.response && error.response.data && error.response.data.message) {
        setError(<FormattedMessage id={error.response.data.message} defaultMessage={error.message} />);
        return;
      }
      setError(<FormattedMessage id="SIGNAGE_DRAFT_SAVED_FAILED" values={{ errorMsg: <b>{error.message}</b> }} />);
      return;
    }
  }

  const cancelSignage = () => {
    const menuId = signageRef.current.menuid || getDefaultTabId(permissionIds);
    const element = document.getElementById(menuId);
    if (element) {
      element.click();
    }
  };

  const getDefaultTabId = (permissionIds) => {
    if (permissionIds.includes(constants.permissionIds.signagePlusOwner)) {
      return 'signagePlusDashboardTab';
    }
    if (permissionIds.includes(constants.permissionIds.signagePlusTeacher)) {
      return 'signagePlusTeacherDashboardTab';
    }
    return null;
  };

  const datetimeProps = {
    scheduler,
    setScheduler,
    startingDateValid,
    setStartingDateValid,
    endingDateValid,
    setEndingDateValid,
    startingTimeValid,
    setStartingTimeValid,
    endingTimeValid,
    setEndingTimeValid,
    recurringValid,
    validated,
    markUnsavedChanges
  }

  return (
    <>
      <AddPlaylist closeModal={closeModal} setSuccess={setSuccess} setError={setError} setZone={setZone} playlistData={zoneData[zone]} zone={zone} setZoneData={setZoneData} markUnsavedChanges={markUnsavedChanges} />
      <NotificationModal {...notificationProps} />
      <WidgetsModel setError={setError} widgetsData={zoneData[zone]} zone={zone} setZone={setZone} closeModal={closeModal} />
      <TickerMessage
        setSuccess={setSuccess}
        setError={setError}
        closeModal={closeModal}
        setZoneData={setZoneData}
        tickerMessageData={zoneData[zone]}
        zone={zone}
        setZone={setZone}
        markUnsavedChanges={markUnsavedChanges}
      />
      <Clock closeModal={closeModal} setSuccess={setSuccess} clockData={zoneData[zone]} zone={zone} setZone={setZone} setZoneData={setZoneData} markUnsavedChanges={markUnsavedChanges} />
      <Weather closeModal={closeModal} setSuccess={setSuccess} weatherData={zoneData[zone]} zone={zone} setZone={setZone} setZoneData={setZoneData} markUnsavedChanges={markUnsavedChanges} />
      <Calendar closeModal={closeModal} setSuccess={setSuccess} calendarData={zoneData[zone]} zone={zone} setZone={setZone} setZoneData={setZoneData} markUnsavedChanges={markUnsavedChanges} />
      <label className="mes-title">
        <FormattedMessage id="CREATE_SIGNAGEE" />
      </label>
      {(signageNameToastValid || zoneListValid) && validated && <div
        className="toast toast-container alert show"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ top: '96px', right: '35px', bottom: 'auto', padding: '0px' }}
      >
        <div className="toast-body signage-error" >
          <img src={xCircleFill} className='icon-44 btn-outline-danger' />
          <span style={{ color: '#222', fontSize: 16 }}>
            <FormattedMessage id="ERROR" /><br />
            <label className='signage-label'><FormattedMessage id={signageNameToastValid || zoneListValid} /></label>
          </span>
        </div>
      </div>}
      {currentPage === 0 ? (
        <SignageMainConfigPanel
          signageName={signageName}
          setSignageName={setSignageName}
          signageNameValid={signageNameValid}
          zoneType={zoneType}
          validated={validated}
          setZoneType={setZoneType}
          zoneOptions={zoneOptions}
          zonePanelsConfig={zonePanelsConfig}
          setPlayListLengthValid={setPlayListLengthValid}
          intl={props.intl}
          setZone={setZone}
          zone={zone}
          zoneData={zoneData}
          markUnsavedChanges={markUnsavedChanges}
        />
      ) : (<div style={{margin: `0px 0px ${currentPage === 1? "360px" : "104px"} 0px`}}>
        <TabsPanel />
        {currentPage === 1 && <ScheduleDateTimePanel
          {...datetimeProps}
        />}
        {currentPage === 2 && <SelectDestination
          treeData={nodes}
          checked={receivers}
          validated={validated}
          onCheck={(check) => { handleReceiversChange(check); markUnsavedChanges(); }}
        />}
        {currentPage === 3 && (
          <>
            <OverviewPanel nodes={nodes} scheduler={scheduler} receivers={receivers} signageName={signageName} isConflict={conflictSignage.length > 0 && currentPage === 3} />
            {conflictSignage.length > 0 && currentPage === 3 && <SignageModal conflictSignage={conflictSignage} />}
          </>
        )}
      </div>
      )}
      <FooterActions
        onLeftClick={() => { currentPage === 0 ? cancelSignage() : setCurrentPage(prev => (prev > 0 ? prev - 1 : 0)); }}
        onMiddleClick={() => { currentPage === 0 ? saveDrafts() : cancelSignage(); }}
        onSave={handleNext}
        leftLabel={leftLabel}
        middleLabel={middleLabel}
        disableMiddle={disableDrafts && currentPage === 0}
        saveLabel={saveLabel}
        disableSave={disableSave && currentPage === 3}
      />
      <Toast
        error={error}
        setError={setError}
        className={"toast-message"}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.user,
  signage: state.signage,
})

export default connect(mapStateToProps)(injectIntl(CreateSignage))
